import { Award } from "lucide-react";

// Color mapping per tier — uses ink/emerald/amber palette to stay on-brand
const TIER_STYLES = {
  Starter: "border-zinc-300 bg-zinc-100 text-zinc-700",
  Bronze: "border-amber-700/30 bg-amber-700/10 text-amber-800",
  Silver: "border-zinc-400/40 bg-zinc-200 text-zinc-800",
  Gold: "border-ec-amber/40 bg-ec-amber/10 text-ec-amber",
  Platinum: "border-emerald-700/30 bg-emerald-700/10 text-emerald-800",
  Diamond: "border-cyan-700/30 bg-cyan-700/10 text-cyan-800",
  Elite: "border-ec-ink bg-ec-ink text-white",
};

export const TIERS_ORDER = ["Starter", "Bronze", "Silver", "Gold", "Platinum", "Diamond", "Elite"];

export const TIER_RANGES = {
  Starter: [0, 149],
  Bronze: [150, 299],
  Silver: [300, 499],
  Gold: [500, 699],
  Platinum: [700, 849],
  Diamond: [850, 949],
  Elite: [950, 1000],
};

export default function TierBadge({ tier = "Starter", size = "md", showIcon = true }) {
  const style = TIER_STYLES[tier] || TIER_STYLES.Starter;
  const sizing = size === "sm"
    ? "text-[10px] px-2 py-0.5 gap-1"
    : size === "lg"
    ? "text-sm px-3 py-1.5 gap-1.5"
    : "text-[11px] px-2.5 py-1 gap-1";
  return (
    <span
      className={`inline-flex items-center font-bold uppercase tracking-wider rounded-full border ${style} ${sizing}`}
      data-testid={`tier-badge-${tier.toLowerCase()}`}
    >
      {showIcon && <Award className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />}
      {tier}
    </span>
  );
}
